var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-restore--wrapper uk-text-right"},[_c('router-link',{staticClass:"password-restore",attrs:{"to":{name: 'passwordRestore'},"tag":"span"}},[_vm._v("Забыли пароль?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }